import { ModuleFE_Account } from '@nu-art/user-account-frontend/index';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
export const composeUserDisplay = (user) => {
    let str = '';
    if (user.title)
        str += user.title;
    if (user.firstName)
        str += ` ${user.firstName}`;
    if (user.surname)
        str += ` ${user.surname}`;
    //If no display was gathered for user, use the connected account
    if (!str.length) {
        const account = ModuleFE_Account.cache.unique(user._id);
        if (!account)
            throw new MUSTNeverHappenException(`Could not get account for id ${user._id}`);
        return account.displayName ?? account.email;
    }
    return str.trim();
};
//# sourceMappingURL=utils.js.map